import { resourcesAsResourceMap } from 'components/helpers/serialisableResources';

export function formatData({ data, resourceTypes }) {
  const included =
    resourceTypes?.length ?
      resourcesAsResourceMap({
        resources: data.included || [],
        resourceTypes,
      })
    : {};

  return {
    data: data.data,
    included,
    meta: data.meta,
  };
}

export function formatInfiniteData({ data, resourceTypes }) {
  return {
    data: data.pages.map((page) => page.data).flat(),
    included:
      resourceTypes?.length ?
        resourcesAsResourceMap({
          resources: data.pages.map((page) => page.included || []).flat(),
          resourceTypes,
        })
      : {},
    meta: data.pages.at(-1).meta,
  };
}

// Used to format conceptual records with relationships that wish to be treated as infinite queries, e.g. a dashboard report that has many projects
export function formatInfiniteRelationship({
  data,
  relationshipKey,
  resourceTypes,
}) {
  return {
    data: {
      ...data.pages.at(-1).data,
      relationships: {
        ...data.pages.at(-1).data.relationships,
        [relationshipKey]: {
          data: data.pages
            .map((page) => page.data.relationships[relationshipKey].data)
            .flat(),
        },
      },
    },
    included:
      resourceTypes?.length ?
        resourcesAsResourceMap({
          resources: data.pages.map((page) => page.included || []).flat(),
          resourceTypes,
        })
      : {},
    meta: data.pages.at(-1).meta,
  };
}

export function getNextPageParam(lastPage, pages) {
  const { currentPage, totalPages } = lastPage.meta;

  // Handles kaminari pagination issue where totalPages is zero but currentPage is higher than 0.
  if (!totalPages || currentPage >= totalPages) return undefined;

  return pages.length + 1;
}

export function isLastResourceOnMultiplePageDataset({ data }) {
  return (
    data.meta.totalPages > 1 &&
    data.meta.currentPage === data.meta.totalPages &&
    data.data.length === 1
  );
}

export function collectData({ queryClient, queryKey }) {
  return queryClient
    .getQueriesData(queryKey)
    .flatMap((queryResult) => {
      const [_unusedKey, queryData] = queryResult;
      if (!queryData) return [];

      if (Array.isArray(queryData.pages)) {
        return queryData.pages.flatMap((page) => page.data);
      } else {
        return queryData.data;
      }
    })
    .filter(Boolean);
}
